export default {
  pt: {
    TRY_AGAIN: 'Tentar novamente',
    CHOOSE_PAYMENT_METHOD: 'Como é que deseja pagar?',
    BUY_NOW: 'Comprar agora',

    // Coupon
    COUPON_TITLE: 'Tem cupom de desconto?',
    COUPON_LABEL: 'Insira o cupom',
    COUPON_BUTTON_LABEL: 'Aplicar',
    COUPON_APPLIED: 'Cupom aplicado',
    COUPON_SNACKBAR_TITLE: 'Você aplicou seu cupom',
    INVALID_COUPON: 'Cupom não existente',

    // Paypal
    PAYPAL_DESCRIPTION:
      'Para poder continuar com a compra deve iniciar sessão com sua conta Paypal',

    // Pagoefectivo - Peru
    PAGO_EFECTIVO_TITLE: 'Selecione seu metodo de pagamento',
    PAGO_EFECTIVO_INSTITUTIONS: 'Você pode fazer seus pagamentos em',
    PAGO_EFECTIVO_TRANSFER:
      'Como fazer uma transferência bancária em dinheiro?',
    PAGO_EFECTIVO_DEPOSIT:
      'Como fazer um depósito em dinheiro através do Pago Efectivo?',

    //  Mexico offline,
    MX_OFFLINE_SELECT_STORE: 'Selecione sua loja preferida',
    MX_OFFLINE_TITLE_1: 'Faça o seu pagamento a qualquer',
    MX_OFFLINE_TITLE_2: 'da república',
    MX_OFFLINE_MAX_AMOUNT: 'Montante máximo: MX$ {{maxAmount}}',
    MX_OFFLINE_COMMISSION: 'Comissão {{storeName}}: MX$ {{amount}}',
    MX_OFFLINE_OXXO:
      'Assim que confirmar a compra, iremos enviar-lhe os dados para o seu email e por SMS. Lembre-se que você só tem 72 horas para fazer o pagamento em qualquer OXXO',
    MX_OFFLINE_SPEI:
      'Assim que confirmar a compra, iremos enviar os dados para o seu email. Lembre-se que você só tem 72 horas para fazer o pagamento em qualquer SPEI',

    // COLOMBIA OFFLINE
    CO_OFFLINE_TITLE: 'Faça seu pagamento em qualquer {{methodName}} do país.',
    CO_OFFLINE_DESCRIPTION:
      'Ao efetuar o pagamento em {{methodName}}, informe que o endereço é para Crehana. O número de referência é o número do seu pedido. Depois de 72 horas, ele será automaticamente cancelado',
    CO_DOCUMENT_LABEL: 'Tipo de documento',

    // pending offline payment
    PENDING_OFFLINE_TITLE:
      'Você já tem um número de cartão de pagamento gerado!',
    PENDING_OFFLINE_DESCRIPTION:
      'Por favor, verifique seu e-mail para ver todas as informações.',
    PENDING_OFFLINE_INFO:
      'Assim que o pagamento for efetuado, sua compra será ativada em 24 horas.',

    // successful offline payment
    SUCCESSFULL_TITLE:
      'Apresente este número em {{storeName}} para fazer seu pagamento.',
    SUCCESSFULL_SUBTITLE: 'Número de cartão',
    SUCCESSFULL_AGREEMENT_NUMBER: 'Número do contrato',
    SUCCESSFULL_REFERENCE_CODE: 'Código de referência',
    SUCCESSFULL_PRINT: 'Imprima seu comprovante de pagamento.',
    SUCCESSFULL_DATE_LABEL: 'Seu prazo de pagamento é:',
    SUCCESSFULL_TIMEOUT_LABEL:
      'Assim que o pagamento for feito, sua compra será ativada em 24 horas',
    SUCCESSFULL_WITHOUT_COMMISSION: 'Não inclui comissão de {{storeName}}',
    SUCCESSFULL_WITH_COMMISSION: 'Inclui comissão SPEI',
    SUCCESSFULL_INFO: 'Pague apenas em {{storeName}}.',
    SUCCESSFULL_BENEFIT: 'O que você aprende hoje o ajudará a melhorar amanhã.',
    SUCCESSFULL_CONEKTA_OXXO:
      'Apresente este número na OXXO para efetuar o seu pagamento e indique que o pagamento será feito através da Conekta.',

    // card number
    CARD_NUMBER_LABEL: 'Número do cartão',
    REQUIRED_CARD_NUMBER: 'Número do cartão obrigatório',
    INVALID_CARD_NUMBER: 'Seu cartão é inválido, tente novamente',
    INCORRECT_CARD_NUMBER: 'Seu cartão é incorreto, tente novamente',
    INCOMPLETE_CARD_NUMBER: 'O número do seu cartão está incompleto.',
    ERROR_CARD_BIN: 'Tente verificar novamente a promoção',
    CARD_DECLINED: 'Cartão recusado, entre em contato com seu banco.',

    // card expiration date
    EXPIRATION_DATE_LABEL: 'MM/AA',
    REQUIRED_EXPIRATION_DATE: 'Data obrigatória',
    INVALID_EXPIRATION_DATE: 'Insira uma data válida',

    // cvv
    CVC_CVV_LABEL: 'CVC/CVV',
    REQUIRED_CVC_CVV: 'CVC/CVV obrigatório',
    INVALID_CVC_CVV: 'CVC/CVV inválido',
    INCORRECT_CVC_CVV: 'CVC/CVV incorrecto',

    // user address
    USER_ADDRESS_LABEL: 'Endereço completo',
    REQUIRED_USER_ADDRESS: 'Endereço obrigatório',

    // province
    PROVINCE_NAME_LABEL: 'Província',
    REQUIRED_PROVINCE_NAME: 'Província obrigatória',

    // department
    DEPARTMENT_NAME_LABEL: 'Departamento',
    REQUIRED_DEPARTMENT_NAME: 'Departamento obrigatório',

    // city
    CITY_NAME_LABEL: 'Cidade',
    REQUIRED_CITY_NAME: 'Cidade obrigatória',

    // state name
    STATE_NAME_LABEL: 'Estado',
    REQUIRED_STATE_NAME: 'Estado obrigatório',

    // zip code
    ZIP_CODE_LABEL: 'CEP',
    REQUIRED_ZIP_CODE: 'CEP obrigatório',
    INVALID_ZIP_CODE: 'CEP inválido',

    // phone number
    PHONE_NUMBER_LABEL: 'Número de telefone',
    REQUIRED_PHONE_NUMBER: 'Número de telefone obrigatório',
    INVALID_PHONE_NUMBER: 'Número inválido',
    INCOMPLETE_PHONE_NUMBER: 'Número incompleto',

    // card holder
    CARD_HOLDER_LABEL: 'Nome no cartão',
    REQUIRED_CARD_HOLDER: 'Nome no cartão obrigatório',

    EMAIL_LABEL: 'Correio eletrônico',
    EMAIL_PLACEHOLER: 'Insira seu e-mail',
    REQUIRE_EMAIL: 'Email obrigatório',

    FULLNAME_LABEL: 'Nomes e sobrenomes',
    OFFLINE_BUTTON_LABEL: 'Gerar código de pagamento',
    NEXT_FORM: 'Continuar',
    PREVIOUS_FORM: 'Voltar aos dados pessoais',

    // document
    IDENTITY_DOCUMENT_LABEL: 'CPF',
    REQUIRED_IDENTITY_DOCUMENT: 'CPF obrigatório',
    INVALID_IDENTITY_DOCUMENT: 'CPF inválido',
    INCOMPLETE_IDENTITY_DOCUMENT: 'CPF incompleto',

    // fullname
    FULLNAME: 'Nome completo',
    REQUIRED_FULLNAME: 'Nome completo obrigatório',
    INVALID_FULLNAME: 'Nome completo inválido',

    // steps
    PERSONAL_INFO: 'Dados pessoais',
    CARD_INFO: 'Dados do cartão',
    ACTIVATION: 'Ativação',
    LAST_STEP: 'Comence a aprender!',
    PAYMENT_STEP: 'Proceso de pago',
    DELIVERY_STEP: 'Datos de envio',

    GO_SAVED_CARD: 'Pagar com cartão salvo',
    GO_BACK: 'Atrás',
    GO_BACK_2: 'Volte',
    DEFAULT_PAYMENT_ERROR: 'O pagamento não foi processado. Tente outra vez',
    CARD_SAVED_ERROR:
      'Não foi possível salvar seu cartão. Recomendamos que você entre em contato com seu banco para obter mais detalhes.',
    ERROR_GENERATE_CODE: 'O código não pode ser gerado! tentar outra vez.',
    PUBLIC_KEY_NO_FOUND: 'Chave pública não encontrada',
    PAYMENT_WARNING:
      'Seu pagamento foi realizado! Porém temos problemas com o sistema. Nossa equipe irá solucionar este inconveniente. Entre em contato com',
    CREHANA_EMAIL: 'oi@crehana.com',
    ADD_SAVED_CARD: 'Adicionar novo cartão de crédito',
    OFFLINE_ERROR_MESSAGE:
      'Ocorreu um erro ao gerar o seu número de compra, tente novamente.',
    QUICK_ENROLL_INFO:
      'Lembre-se de que todo o seu crédito será usado para esta compra.',
    QUICK_BUTTON_LABEL: 'Comece agora',
    GUARANTEE_INFO:
      'Se sua experiência de compra não foi como você esperava, nós lhe oferecemos um reembolso de 100% do seu pagamento. Por favor confira as nossas',
    MS_GUARANTEE_SHORT:
      'Reembolsaremos sua compra 100% se você não estiver satisfeito com sua assinatura. *',
    PAYG_GUARANTEE_SHORT:
      'Se sua experiência de compra não foi como você esperava, nós lhe oferecemos um reembolso de 100% do seu pagamento. Por favor confira as nossas',
    CATCH_MESSAGE: 'O pagamento não foi processado. Tente outra vez',
    CHECKOUT_GENERIC_ERROR: 'O pagamento não foi processado. Tente outra vez',
    CATCH_MESSAGE_COUPON:
      'Não foi possível processar o cupom! Tente novamente.',
    PAYMENT_DISCLAIMER:
      'A cobrança será de US$ {{totalToPayInDollars}}, os preços básicos que administramos são em dólares americanos. O valor que você vê em sua moeda local é um valor aproximado que pode variar de acordo com seu banco e a taxa de câmbio do dia, está sujeito aos impostos de cada país, que será assumido pelos usuários finais.',
    TERMS_CONDITIONS_TITLE: 'Termos e Condições',
    TERMS_CONDITIONS_DESCRIPTION:
      '(1) Aceito expressamente todos os Termos e Condições de Assinaturas Premium e Pay As You Go. Da mesma forma, aceito as Políticas e Avisos de Proteção e Tratamento de Dados Pessoais de Crehana: Generales, Colômbia, México.',
    SHORT_PAYMENT_TAG: 'Total',
    LONG_PAYMENT_TAG: 'Total a pagar',
    PAYMENT_FORM_TITLE: 'Insira os seus dados',
    TIMER_LABEL: 'A oferta termina em',
    SAFE_LABEL: 'Pagamento 100% seguro',
    GREETING: 'Olá',
    ADVISOR_LABEL: 'Seu orientador educacional',
    EXPIRATION_DESCRIPTION:
      'A oferta que você está procurando não está mais disponível, se você quiser, entre em contato com seu orientador educacional novamente:',
    PROMOTION_MESSAGE:
      'Oferta válida apenas durante a ligação com o agente educacional',
    EXPIRATION_EMAIL_TAG: 'Comunicar com você',
    CONTACT_US:
      'Se você tiver alguma dúvida, entre em contato conosco de segunda a sexta-feira, das 09:00 am às 7:00 pm',
    DISCOUNT_TAG: 'Primeira compra',
    CREDIT_TAG: 'Créditos',
    CASHBACK_TAG: 'Reembolso (cashback)',
    SUBTOTAL_TAG: 'Subtotal',
    CHECKBOX_LEGAL: 'expressamente todos os',
    CHECKBOX_LEGAL_FULL:
      'expressamente todos os Termos e Condições da Assinatura Premium.',
    LEGAL_LINK_TEXT: 'Termos e Condições',
    LEGAL_ERROR_TEXT:
      'Você precisa aceitar os termos e condições para continuar.',
    CHECKBOX_LABEL: 'Eu aceito ',
    DEGREE_GUARANTEE:
      ' Caso sua experiência com o MicroDegree não corresponda às suas expectativas e você deseja solicitar uma reembolso, deve-se levar em consideração as',
    REFUND_POLICIES: 'Políticas de Reembolso.',
    DEGREE_BENEFIT_TITLE: 'Por que usar nossos MicroDegrees?',
    BOOTCAMP_BENEFIT_TITLE: 'Por que usar nossos Bootcamps?',
    DEGREE_BENEFIT_1:
      'Certificado online por parceiros universitários reconhecidos na América Latina',
    DEGREE_BENEFIT_2: 'Duração de 4 meses',
    BOOTCAMP_BENEFIT_2: 'Duração de 1 mes',
    DEGREE_BENEFIT_3: 'Asesorías y mentorías en vivo',
    USERPROOF_LABEL:
      'Há {{userQuantity}} pessoas que estão a comprar o mesmo que você do {{countryName}}',
    CAMPAIGN_TIMER_LABEL: 'Não perca esta oportunidade!',
    PAYMENT_DETAIL_TITLE: 'Informação de pagamento',
    // Checkout V4
    LABEL_HEADER_CHECKOUT: '¿Tem certeza que quer sair?',
    BUTTON_LABEL_HEADER_CHECKOUT_1: 'Ir para a página anterior',
    BUTTON_LABEL_HEADER_CHECKOUT_2: 'Fique aqui',
    // premium benefit
    PREMIUM_BENEFIT_1: 'Acesso a +1000 cursos e especializações',
    PREMIUM_BENEFIT_2: 'Mentoria e conteúdo exclusivo',
    PREMIUM_BENEFIT_3: 'Válido por {{yearNumber}} ano, auto-renovável',
    PREMIUM_BENEFIT_4: 'Válido por {{monthNumber}} meses, auto-renovável',
    LITE_BENEFIT: 'Válida por {{monthNumber}} meses',

    // Legals
    MOBILE_GUARANTEE_TITLE: '* Garantia de 14 dias',
    MOBILE_DISCLAIMER_TITLE: 'Sobre a coleção',

    GO_PAYMENT_METHODS: 'Outros métodos de pagamento',
    CHECKBOX_DATA_USAGE:
      'Autorizo ​​a Crehana a usar os dados fornecidos para entrar em contato comigo e receber promoções, ofertas e informações de produtos novos.',

    INSUFFICIENT_FUNDS:
      'Nosso sistema nos diz que você não tem fundos suficientes.',
    EXPIRED_CARD: 'Seu cartão está expirado, entre em contato com seu banco',
    INVALID_CARD: 'Seu cartão é inválido, tente novamente',
    INVALID_INFO_CARD: 'Seu cartão é incorreto, tente novamente',

    // Crehana errors
    DEACTIVATE_SUBSCRIPTION: 'A associação não está ativa',
    ALREADY_PURCHASED: 'Você já tem este curso em sua conta',
    PENDING_PAYMENT_CODE: 'Você já tem um pagamento pendente',
    ALREADY_ITEM_PENDING_CODE:
      'Você já tem um pedido pendente para este produto',
    INVALID_ITEM: 'O produto que você deseja comprar não é válido',

    // Saved Cards
    CVV_VALIDATION:
      'Para validar sua compra com este cartão, precisamos que você escreva o código de segurança',

    // Payments Loader
    PROCESSING_PAYMENT: 'Processando compra ...',
    VERIFYING_PAYMENT: 'Verificando o pagamento ...',
    COMPLETING_TRANSACTION: 'Concluindo transação...',
    GENERATING_CODE: 'Gerando código ...',
    GENERATING_DATA: 'Gerando dados ...',

    // User input field
    DOCUMENT_DROPDOWN_HINT: 'Selecione o tipo de documento',
    DOCUMENT_TYPE_LABEL: 'Tipo de documento',
    REQUIRED_FIELD: 'Campo obrigatório',

    CHOOSE_QUOTA: 'Escolha a sua quota',
    // Hot sale
    HOT_SALE_MESSAGE: 'Não perca esta oportunidade!',

    // Countdown
    DAYS_LABEL: 'Dias',
    HOURS_LABEL: 'Horas',
    MINUTES_LABEL: 'Mins',
    SECONDS_LABEL: 'Segs',
  },
};
